import Vue from 'vue'
import Vuex from 'vuex'
import modelMapper from '@/stores/modelMapper'
import globalLoading from '@/stores/globalLoading'
import breadcrumb from '@/stores/breadcrumb'
import apps from '@/stores/apps'
import partner from '@/stores/partner'
import theme from '@/stores/theme'

Vue.use(Vuex)

export default new Vuex.Store({
  actions: {
    ...apps.actions,
  },
  getters: {
    ...modelMapper.getters,
    ...globalLoading.getters,
    ...breadcrumb.getters,
    ...apps.getters,
    ...partner.getters,
    ...theme.getters,
    getAccount: state => state.account,
    getPolicies: (state => state.user.currentPolicies),
    getUser: state => state.user,
    usesPermissionGroups: state => !!(state.user && state.user.usesPermissionGroups),
    hasAccount: (state, getters) => !!getters.getAccount,
    hasUser: (state, getters) => !!getters.getUser
  },
  mutations: {
    ...modelMapper.mutations,
    ...globalLoading.mutations,
    ...breadcrumb.mutations,
    ...apps.mutations,
    ...partner.mutations,
    ...theme.mutations,
    setAccount (state, account) {
      if (account) {
        account = Vue.parse.toCamelcase(account)
        Vue.ls.set('last_account_id', account.id, { minutes: 60 * 24 * 365, withoutKey: true })
      }

      state.account = account
      state.user.account = account
    },
    setUser (state, user) {
      if (user) {
        user = Vue.parse.toCamelcase(user)
        if (user.currentAccount) {
          user.account = user.currentAccount
          delete user.currentAccount
          state.account = user.account
        }
      }
      state.user = user
    }
  },
  state: {
    ...modelMapper.state,
    ...globalLoading.state,
    ...breadcrumb.state,
    ...apps.state,
    ...partner.state,
    ...theme.state,
    account: null,
    user: null,
  }

})
